import { useEffect, useState } from 'react';
import { produce } from 'immer';
import { useNavigate, useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';

import { useSaveHsptlzFormCcrc } from './mutation';

export const useSavePdf = () => {
  const navigate = useNavigate();
  const { contentCode } = useParams();
  const { hspId, usrId, hsptlzRsvNo } = useBoundStore((state) => state.hsptlzForm.serviceParams);
  const processFormData = useBoundStore((state) => state['hsptlzForm'].processFormData);
  const submittedFormData = useBoundStore((state) => state['hsptlzForm'].submittedFormData);
  const setProcessFormData = useBoundStore((state) => state['hsptlzForm'].setProcessFormData);
  const setSubmittedFormData = useBoundStore((state) => state['hsptlzForm'].setSubmittedFormData);
  const caregiverData = useBoundStore((state) => state['hsptlzForm'].caregiverData);
  const contentDetailData = useBoundStore((state) => state['hsptlzForm'].contentDetailData);
  const sign = useBoundStore((state) => state['hsptlzForm'].sign);
  const [consentFile, setConsentFile] = useState(null);
  const { mutate, data } = useSaveHsptlzFormCcrc();
  useEffect(() => {
    const { contentVersion, contentDetailCodeList } = processFormData[contentCode];
    const contentDetailAnswerList = contentDetailCodeList.map((code) => contentDetailData[code].value);
    if (consentFile) {
      mutate({
        params: {
          hspId,
          usrId,
          hsptlzRsvNo,
          contentVersion,
          contentCode,
          contentDetailCodeList,
          contentDetailAnswerList,
          consentFile,
          signFile: sign['sign-all'] || null,
          ...caregiverData,
        },
        navigate,
      });
    }
  }, [consentFile]);

  useEffect(() => {
    if (data) {
      setSubmittedFormData(
        produce(submittedFormData, (draft) => {
          draft[contentCode] = { ...processFormData[contentCode], completed: 'Y' };
        }),
      );

      setProcessFormData(
        produce(processFormData, (draft) => {
          delete draft[contentCode];
        }),
      );
      navigate('/hsptlz/form/complete', {
        replace: true,
        state: { isSuccess: data.data.result == 0, talkChannelReturnUrl: data.data.talkChannelReturnUrl },
      });
    }
  }, [data]);

  return { setConsentFile };
};
